export const navigation = ["Profile",
    "Experience",
    "Projects",
    "Skills",
    "Certifications",
    "Education",
]